import React from 'react'
import styles from './CardTable.module.scss'

// a row, because it is rendered inside the CardTable body
export const CardTableNoResults = ({ label }) => (
  <tr className={styles.noResults}>
    <td>{label}</td>
  </tr>
)
